import React from "react"
import styled from "styled-components"
import { Settings } from "../../../styles/theme"

const Carouselstyle = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  > div {
    flex: 1 1 ${props => (props.slide ? 100 / props.slide : 100)}%;
    display: none;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: ${props => (props.stackable ? "1 1 50%" : "")};
    }
  }
  .active {
    display: block;
  }
  > span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    pointer-events: none;
    color: ${Settings.secondaryColor};
    font-weight: 700;
    font-size: 1.4rem;
    cursor: pointer;
    &:first-of-type {
      left: -2%;
      text-align: left;
    }
    &:last-of-type {
      right: -2%;
      text-align: right;
    }
  }
  .show {
    pointer-events: all;
    opacity: 1;
  }
  .circles {
    position: absolute;
    bottom: -2rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
  }
`

const Circle = styled.div`
  height: 12px;
  width: 12px;
  border: 1px transparent;
  border-radius: 50%;
  background: ${"rgba(0,0,0,1)"};
  opacity: ${props => (props.selected ? 0.5 : 0.2)};
  cursor: pointer;
  margin: 0 1rem;
  flex: 1;
  display: inline-block;
`

class Carousel extends React.Component {
  constructor(props) {
    super(props)
    const totalSlides = Math.ceil(
      React.Children.count(props.children) / props.slide
    )
    this.state = {
      selected: 1,
      total: totalSlides,
    }
  }

  setSelected = i => {
    this.setState({
      selected: i,
    })
  }

  render() {
    return (
      <Carouselstyle slide={this.props.slide} stackable={this.props.stackable}>
        <span
          className={this.state.selected !== 1 ? "show" : "hide"}
          onClick={() => this.setSelected(this.state.selected - 1)}
          style={
            this.props.noArrows ? { display: "none" } : { display: "block" }
          }
        >
          {"<"}
        </span>
        <span
          className={this.state.total > this.state.selected ? "show" : "hide"}
          onClick={() => this.setSelected(this.state.selected + 1)}
          style={
            this.props.noArrows ? { display: "none" } : { display: "block" }
          }
        >
          {">"}
        </span>
        <section
          className="circles"
          style={this.props.nodot ? { display: "none" } : { display: "block" }}
        >
          {[...Array(this.state.total)].map((child, i) => (
            <Circle
              onClick={() => this.setSelected(i + 1)}
              selected={this.state.selected === i + 1}
            />
          ))}
        </section>
        {this.props.children.map((slide, index) => {
          return React.cloneElement(slide, {
            key: index,
            className:
              this.state.selected === Math.ceil((index + 1) / this.props.slide)
                ? "active"
                : "",
          })
        })}
      </Carouselstyle>
    )
  }
}

export default Carousel
